module.exports = __webpack_public_path__ + "static/media/Home Diagnostic Service.75a2b353.png";